import { SituacaoNota } from '../../../../../../_metronic/helpers'
import { createListFilters, IOption } from '../../../../../components'

export type NotasFilters = {
  empresa?: IOption<number>
  mes?: IOption<string>
  ano?: IOption<number>
  situacao?: IOption<SituacaoNota>
  /** Só na visão do financeiro (fora de /profissional). */
  profissional?: IOption<string>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<NotasFilters>({
  empresa: undefined,
  mes: undefined,
  ano: undefined,
  situacao: undefined,
  profissional: undefined,
})
